import { coverInKgPerHaToDryMatter } from "common/utils/helpers";
import { ArableField } from "model/arableFieldTypes";
import { ARABLE_TYPE } from "model/commonTypes";
import { Field } from "model/fieldTypes";

const GRAIN_TYPES = ["WHEAT", "BARLEY", "CEREALS"];
const NON_GRAIN_TYPES = [
  "OILSEED_RAPE",
  "POTATO",
  "MAIZ",
  "VEGETABLES_SALAD",
  "OTHERS",
];

export function getGrainFieldsFromArray(
  arableFields: ArableField[]
): ArableField[] {
  return arableFields.filter(
    (field) =>
      field &&
      field.arableType &&
      Object.values(ARABLE_TYPE).includes(field.arableType) &&
      GRAIN_TYPES.includes(field.arableType)
  );
}

export function getArableFieldsFilteredFromArray(
  arableFields: ArableField[]
): ArableField[] {
  return arableFields.filter(
    (field) =>
      field &&
      ((field.arableType && NON_GRAIN_TYPES.includes(field.arableType)) ||
        !field.arableType)
  );
}

export function getSilageFieldsFromMetrics(fields: Field[]): Field[] {
  return fields.filter((field) => !field.animalGroup);
}

export function getPastureFieldsFromArray(fields: Field[]): Field[] {
  return fields.filter((field) => field.animalGroup);
}

export function getGrainFieldMetricsFromArray(grainFields: ArableField[]) {
  const fieldCount = grainFields.length;
  const totalArea = grainFields.reduce((acc, field) => {
    if (field && !field.invalidatedTimestamp) {
      acc += field.area / 10000;
    }
    return acc;
  }, 0);
  return {
    fieldCount,
    totalArea: Math.round(totalArea * 100) / 100,
  };
}

export function getArableFieldMetricsFromArray(arableFields: ArableField[]) {
  const fieldCount = arableFields.length;
  const totalArea = arableFields.reduce((acc, field) => {
    if (field && !field.invalidatedTimestamp) {
      acc += field.area / 10000;
    }
    return acc;
  }, 0);
  return {
    fieldCount,
    totalArea: Math.round(totalArea * 100) / 100,
  };
}

export function getSilageFieldMetricsFromArray(silageFields: Field[]) {
  const fieldCount = silageFields.length;
  const totalArea = silageFields.reduce((acc, field) => {
    if (!field.invalidatedTimestamp) {
      acc += field.area / 10000;
    }
    return acc;
  }, 0);
  const totalDryMatter = silageFields.reduce((acc, field) => {
    if (!field.invalidatedTimestamp) {
      acc += coverInKgPerHaToDryMatter(field.dryMatterNow, field.area);
    }
    return acc;
  }, 0);
  return {
    fieldCount,
    totalArea: Math.round(totalArea * 100) / 100,
    totalDryMatter: Math.round(totalDryMatter),
  };
}
